import { Id } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import url from 'url'
import {
  convertStoreUserNonAvailability,
  convertStoreUserNonAvailabilityList,
} from './shared/convert'
import keys from './shared/keys'
import { StoreUserNonAvailabilityResponse } from './shared/response'
import {
  NonAvailabilityList,
  NonAvailabilityQueryParams,
  StoreUserNonAvailability,
} from './types'

export function useNonAvailability(params: NonAvailabilityQueryParams) {
  const { server } = useServer()

  return useQuery<StoreUserNonAvailability>({
    queryKey: keys.detail(params),
    queryFn: fetchNonAvailability,
    refetchOnMount: 'always',
  })
  async function fetchNonAvailability(): Promise<StoreUserNonAvailability> {
    const response =
      await server.get<StoreUserNonAvailabilityResponse.StoreUserNonAvailability>(
        getUrl(params)
      )

    return convertStoreUserNonAvailability(response)
  }
}

function getUrl(params: NonAvailabilityQueryParams) {
  const pathname = '/v2/non_availability'
  if (params?.storeId) {
    return url.format({
      pathname,
      query: {
        store_id: params.storeId,
      },
    })
  }

  if (params?.requestId) {
    return `${pathname}/${params.requestId}`
  }

  throw new Error('Invalid params')
}

export function useNonAvailabilityList(storeId: Id | undefined) {
  const { server } = useServer()

  return useQuery({
    queryKey: storeId ? keys.list(storeId) : [],
    queryFn: fetchNonAvailabilitiesList,
    enabled: !!storeId,
  })

  async function fetchNonAvailabilitiesList(): Promise<NonAvailabilityList> {
    if (!storeId) {
      throw new Error('Illegal store ID')
    }
    const response =
      await server.get<StoreUserNonAvailabilityResponse.NonAvailabilityList>(
        url.format({
          pathname: `/v2/non_availabilities/`,
          query: {
            store_id: storeId,
          },
        })
      )

    return convertStoreUserNonAvailabilityList(response)
  }
}
